/**
 * 1-Click CSV / Excel Exporter for Admin Dashboard
 * Generates and downloads a clean CSV file from any table records.
 *
 * @param {string} title - Table or export title
 * @param {Array} columns - Column definition array with key/header
 * @param {Array} data - Filtered record array
 */
export const exportToCsv = (title = 'export', columns = [], data = []) => {
  if (!data || data.length === 0) {
    alert('No records available to export.');
    return;
  }

  // 1. Determine Headers
  const exportColumns = columns && columns.length > 0
    ? columns.filter(c => c.key && c.key !== 'actions' && c.header !== 'Actions')
    : Object.keys(data[0]).map(k => ({ key: k, header: k }));

  const headers = exportColumns.map(c => `"${String(c.header || c.key).replace(/"/g, '""')}"`).join(',');

  // 2. Format Rows
  const rows = data.map(row => {
    return exportColumns.map(col => {
      let val = row[col.key];

      // Handle nested or complex types
      if (val === null || val === undefined) {
        val = '';
      } else if (typeof val === 'object') {
        if (Array.isArray(val)) {
          val = val.map(item => (typeof item === 'object' ? item.title || item.name || JSON.stringify(item) : item)).join('; ');
        } else {
          val = JSON.stringify(val);
        }
      }

      // Escape quotes for CSV standard
      const stringVal = String(val).replace(/"/g, '""');
      return `"${stringVal}"`;
    }).join(',');
  });

  const csvContent = '\uFEFF' + [headers, ...rows].join('\r\n'); // Add UTF-8 BOM for Excel compatibility

  // 3. Trigger Browser File Download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  const sanitizedTitle = (title || 'records')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/(^_|_$)/g, '');

  const dateStr = new Date().toISOString().split('T')[0];
  link.setAttribute('href', url);
  link.setAttribute('download', `${sanitizedTitle}_${dateStr}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
